import { useTranslation } from "react-i18next";
import { Modal, ModalFooter } from "@/components/ui/Modal";
import Textarea from "@/components/ui/Textarea";
import Button from "@/components/ui/Button";

const MAX_SELLER_NOTES_LENGTH = 1000;

interface BookingSellerNotesModalProps {
  isOpen: boolean;
  bookingId: string | null;
  notes: string;
  isSaving: boolean;
  onNotesChange: (value: string) => void;
  onClose: () => void;
  onSave: (bookingId: string, sellerNotes: string) => void;
}

export function BookingSellerNotesModal({
  isOpen,
  bookingId,
  notes,
  isSaving,
  onNotesChange,
  onClose,
  onSave,
}: BookingSellerNotesModalProps) {
  const { t: tCommon } = useTranslation("common");
  const { t } = useTranslation("bookings");

  const handleSave = () => {
    if (!bookingId) return;
    onSave(bookingId, notes.slice(0, MAX_SELLER_NOTES_LENGTH));
  };

  return (
    <Modal
      closeLabel={tCommon("close")}
      isOpen={isOpen}
      onClose={onClose}
      title={t("sellerNotesModal.title")}
      description={t("sellerNotesModal.description")}
      size="md"
      dismissOnBackdrop={!isSaving}
      footer={
        <ModalFooter>
          <Button variant="outline" onClick={onClose} disabled={isSaving}>
            {t("common:cancel")}
          </Button>
          <Button variant="primary" onClick={handleSave} isLoading={isSaving}>
            {t("sellerNotesModal.save")}
          </Button>
        </ModalFooter>
      }
    >
      <Textarea
        label={t("detail.sellerNotes")}
        placeholder={t("sellerNotesModal.placeholder")}
        value={notes}
        onChange={(event) =>
          onNotesChange(event.target.value.slice(0, MAX_SELLER_NOTES_LENGTH))
        }
        rows={5}
        disabled={isSaving}
      />
    </Modal>
  );
}
